import { KnownInboxLabel } from "@qw/qw-common";
import { Button, cn, Icon } from "@qw/ui";
import type { FC } from "react";

import { useAddLabelToConversation } from "../providers/use-add-label-to-conversation";
import { useConversation } from "../providers/use-conversation";
import { useRemoveLabelFromConversation } from "../providers/use-remove-label-from-conversation";

export const ConversationStarButton: FC = () => {
  const { inboxConversation } = useConversation();
  const [addLabel] = useAddLabelToConversation();
  const [removeLabel] = useRemoveLabelFromConversation();

  if (!inboxConversation) {
    return null;
  }

  const starred = inboxConversation.labels.includes(KnownInboxLabel.STARRED);

  return (
    <Button
      variant="ghost"
      size="sm"
      display="icon"
      onClick={() =>
        starred
          ? removeLabel(inboxConversation, KnownInboxLabel.STARRED)
          : addLabel(inboxConversation, KnownInboxLabel.STARRED)
      }
    >
      <Icon icon="star" className={cn(starred && "filled text-yellow-500")} />
    </Button>
  );
};
